import { render } from "./ConfirmationPage.vue?vue&type=template&id=6df3ac2e&scoped=true"
import script from "./ConfirmationPage.vue?vue&type=script&lang=ts"
export * from "./ConfirmationPage.vue?vue&type=script&lang=ts"

import "./ConfirmationPage.vue?vue&type=style&index=0&id=6df3ac2e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6df3ac2e"
/* hot reload */
if (module.hot) {
  script.__hmrId = "6df3ac2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6df3ac2e', script)) {
    api.reload('6df3ac2e', script)
  }
  
  module.hot.accept("./ConfirmationPage.vue?vue&type=template&id=6df3ac2e&scoped=true", () => {
    api.rerender('6df3ac2e', render)
  })

}

script.__file = "src/views/registerTeam/ConfirmationPage.vue"

export default script